import { siteInfo, footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-white"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">
                {siteInfo.name}
              </span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4 max-w-xs">
              {siteInfo.footerDesc}
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-200 hover:bg-primary-600 hover:text-white transition-colors cursor-pointer" aria-label="首页">
                <i className="ri-home-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-200 hover:bg-primary-600 hover:text-white transition-colors cursor-pointer" aria-label="联系我们">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a href="#app" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-200 hover:bg-primary-600 hover:text-white transition-colors cursor-pointer" aria-label="移动端">
                <i className="ri-smartphone-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容品牌</h4>
            <ul className="space-y-2.5">
              {footerLinks.content.map((link) => (
                <li key={link.label}>
                  <a href={link.url} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">服务导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.service.map((link) => (
                <li key={link.label}>
                  <a href={link.url} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              糖心视频与蜜桃视频、桃子视频、苹果视频、榴莲视频、芒果视频等甜蜜水果品牌深度合作，持续为用户带来超清画质、极速播放的优质观影体验。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/60">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 {siteInfo.name} - 甜蜜水果品牌超清在线观影平台 · 保留所有权利
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>蜜桃视频</span>
            <span className="text-foreground-700">·</span>
            <span>桃子视频</span>
            <span className="text-foreground-700">·</span>
            <span>苹果视频</span>
            <span className="text-foreground-700">·</span>
            <span>榴莲视频</span>
            <span className="text-foreground-700">·</span>
            <span>芒果视频</span>
          </div>
        </div>
      </div>
    </footer>
  );
}